let _this;
import cameraAndUpload from './uploadUserFace.vue'
import tagsCheck from '../commonComponents/tagsCheck.vue'
import accessCodeDetail from '../staffManagement/accessCodeDetail.vue'
import sameUserDetected from './fastSameUserDetected.vue'
import dcsZone from '../commonComponents/dcsZoneCheck.vue'
import profilePhotoUpload from './profilePhotoUpload.vue'
export default {
  name: "visitor-register",
  components: {cameraAndUpload, tagsCheck,accessCodeDetail,sameUserDetected,dcsZone,profilePhotoUpload},
  data() {
    let palmVeinList = window.g.pocPalmVeinDeviceList
	_this = this;
    return {
      userInfo:{
        targetNodeId:'',
        officeId:'',
        name:'',
        tagIds:[],
        addIdentityCards: [{type: this.ApiService.identityInfo.displays.Visitor, no: "",canIdentify:true}],
        accessRule:1,
        areaCode:this.ApiService.defaultAreaCode,
        enableState:true,
        attachments:[],
        faceFileBase64:'',
        pin:this.ApiService.pinSettingInfo.isSetDefaultValue ? _this.ApiService.pinSettingInfo.defaultValue : null,
        addUserDCSRelations:[],
        createFingerprints: [],
        profilePhotoBase64:"",
        palmPrintFeature:'',
        palmprintPhotoFileBase64:''
      },
      timeZoneId:'',
      cardNoFlag:false,
      options1:{
        disabledDate(date) {
          return date.valueOf() <  new Date().getTime() - 86400000;
        }
      },
      userACInfo:{},
      accessCodeFlag:false,
      acValidityFlag:false,
      acTitleData:[
        {
          title: _this.ApiService.accessCodeName,
          slot: 'accessCodeName',
          minWidth: 150,
          sortable: 'custom'
        },{
          title: 'Source',
          key: 'source',
          minWidth: 150,
        },
        {
          title: 'Validity',
          slot:'validity',
          minWidth: 320,
        },{
          title: 'Host',
          key: 'hostName',
          minWidth: 150,
        },{
          title: 'Operator',
          key: 'operatorName',
          minWidth: 150,
        },{
          title: 'Last Update',
          slot:'lastUpdateTime',
          minWidth: 150,
          sortable: 'custom'
        },{
          title: 'Status',
          slot:"viewStatus",
          minWidth: 150,
          sortable: 'custom'
        },{
          title: 'Operation',
          slot: 'operation',
          width: 150,
          align: 'left',
        },
      ],
      acTabIndex:0,
      accessCodeModal:false,
      cardList:[],
      viewBasicInfo:{tagArray:[],cardNo:''},
      cardTagList:[],
      cardTagIds:[],/*卡tagid*/
      noACStr:"<div class='utm-table-nodata'><i class='utm-font utm-access-code'></i><p> No Data </p></div>",/*无AC时数据显示*/
      accessCodeList:[],
      searchACTimer:'',
      searchAC:{},
      accessCodeName:"",
      editACFlag:false,
      userACData:[],
      customFields:[],
      userId:'',
      curCardInfo:{},/*卡信息*/
      hostList:[],
      hostTimer:[],
      isNeedAttachment:this.ApiService.attachmentInfo.isEnable && this.ApiService.attachmentInfo.userTypes.indexOf(1) > -1,/*是否需要附件*/
      cardSearTimer:'',/*卡搜索定时器*/
      enablePIN:this.ApiService.pinSettingInfo.enableds.indexOf(1) > -1,/*启用PIN*/
      requirePIN:this.ApiService.pinSettingInfo.mandatorys.indexOf(1) > -1,/*PIN是否必填*/
      lastTime:0,/*上次输入卡号时间*/
      noCardFlag:false,/*刷卡不存在*/
      exitSingleEntry:true,
      acPage:1,/*AC页码*/
      acTagList:[],
      acTagIds:[],
      sameUserCount:0,/*相同的user数量*/
      profileList:[],
      hostFlag:false,
      hidePsdFlag:!this.ApiService.pinSettingInfo.isVisible,
      isOrganizationCheck:false,
      departmentArray:[],/*部门*/
      departmentFlag:false,
      enableAccessRule:this.ApiService.singleEntry.enableAccessRule && this.ApiService.singleEntry.userTypes.indexOf(1) > -1,
      dCSFlag:false,
      dcsTipModal: false,
      searchCard:{page:1},
      searchHost:{page:1},
      classType:0,
      displayACData:[],/* 展示的AC */
      showTipPro:false,
      isVirtualCard:true,
      fastInfo:{
        isfast: true,
        type:1
      },
      //DCS相关
      dcsModal:false,
      editDcsFlag:false,
      dcsArr:{},
      diplayDCS:[],
      deleteDCS:'',
      deleteModal:false,
      deleteType:0,//0=AC,2=DCS
      editIndex:0,
      palmVeinDialog:false,
      palmVeinSelectModel:'',
      palmVeinList: palmVeinList,
      isStartSocket:false,
      pocSocket:null,
      pocStart:false,
      palmVeinDeviceList:[],
      palmVeinFlag:false
    }
  },
  mounted(){ 
    _this = this;
    _this.getDepartments();
    _this.setCustomFields();
    _this.initInfo();
    _this.hasSingleEntry();
    _this.getACTagList();
    _this.shareApi.getDCSProfileList(_this);
  },
  watch:{
    'userACData':{
      handler(val){
        _this.changeACClass(_this.classType);
      },
      deep:true
    },
    palmVeinDialog(){
      if(!this.palmVeinDialog){
        this.palmVeinFlag = false
      }
    }
  },
  beforeDestroy(){
    _this.userInfo.targetNodeId = _this.$root.curNodeInfo.id || _this.userInfo.targetNodeId;
    // 切换user类型，保留信息
    if($.isEmptyObject(_this.$root.swipeCardInfo)){
      _this.$root.swipeCardInfo = {
        name:_this.userInfo.name,
        idType : _this.userInfo.addIdentityCards[0].type,
        idNumber:_this.userInfo.addIdentityCards[0].no
      }
    }
  },
  methods: {
    deletePalmVein(){
      this.userInfo.palmPrintFeature = ''
      this.userInfo.palmprintPhotoFileBase64 = ''
   },
   linkPoc(){
     if(!this.palmVeinSelectModel){
       this.palmVeinFlag = true;
       return
     }
     this.deletePalmVein();
      let device= JSON.parse(this.palmVeinSelectModel) 
      this.isStartSocket = true
      this.pocStart = true
      this.pocSocket = new WebSocket('wss://' + device.ipAddress + ':' + device.port);
       this.pocSocket.onopen = function(event) {
         console.log('WebSocket connected');
       };

       this.pocSocket.onmessage = function(event) {
         let palmObj =  JSON.parse(event.data)
         _this.userInfo.palmprintPhotoFileBase64 = palmObj.imageBase64
          palmObj.imageBase64 = undefined
         _this.userInfo.palmPrintFeature = JSON.stringify(palmObj)
         _this.pocSocket.close(); // 接收到数据后自动关闭WebSocket连接
       };

       this.pocSocket.onclose = function(event) {
         console.log('WebSocket connection closed');
         _this.isStartSocket= false
       };

       this.pocSocket.onerror = function(error) {
         console.error('WebSocket error:', error);
       };
   },
   closePoc(){
     this.pocSocket.close();
     this.isStartSocket= false
   },
   openPalmVein(){
      this.$refs.palmVein.palmVeinDialog = true
   },
    changeNode:function (data) {
      if(data){
        _this.userInfo.targetNodeName = data.label;
      _this.getNodeConfig();
        _this.getDefaultAutoAC();
      }
      else if(!_this.$route.params.id){
        _this.getNodeConfig();
        _this.getDefaultAutoAC();
      }
    },
    changeOffice:function(office){ 
      //更新了时区后需要重新计算AC的有效期状态
      this.userInfo.officeName = office.name;
      this.userInfo.timeZoneName = office.timeZoneName;
      this.timeZoneId = office.timeZoneId;
      console.log('切换Office');
      _this.getDefaultAutoAC();
    },
    getNodeConfig:function (isFirst) {
      _this.shareApi.getNodeUserConfig(_this.userInfo.targetNodeId,updatePage);
      function updatePage() {
        _this.userInfo.areaCode = _this.ApiService.defaultAreaCode;
        _this.userInfo.pin = _this.ApiService.pinSettingInfo.isSetDefaultValue ? _this.ApiService.pinSettingInfo.defaultValue : '';
        _this.isNeedAttachment = _this.ApiService.attachmentInfo.isEnable && _this.ApiService.attachmentInfo.userTypes.indexOf(0) > -1;/*是否需要附件*/
        _this.getDepartments();
        if(isFirst){
          if(_this.userInfo.cardId){
            _this.cardList = [];
            _this.getCardList();
          }else{
            if(_this.ApiService.cardSettingInfo.isEnable && _this.ApiService.cardSettingInfo.requiredUserTypes.indexOf(1) > -1){
              //卡功能打开且卡号为必填才自动分配
              _this.getAutoAssignCard();
            }
          }
        }else{
          if(_this.isVirtualCard || !_this.userInfo.cardId){
            //当前卡号是实体卡切换节点不重新分配
            if(_this.ApiService.cardSettingInfo.isEnable && _this.ApiService.cardSettingInfo.requiredUserTypes.indexOf(1) > -1){
             //卡功能打开且卡号为必填才自动分配
            _this.getAutoAssignCard();
            }else{
                _this.$set(_this.userInfo,'cardId','');
                _this.$set(_this.viewBasicInfo,'cardNo','');
                _this.curCardInfo = {cardExtensions:[]};
            }
          }
        }
        _this.getCardTags(true);
        if(_this.$refs.uploadFace){
          _this.$refs.uploadFace.initInfo();
        }
        // 切换节点获取 是否配置 可用和必填的key
        if(_this.$refs.photoUpload){
          _this.$refs.photoUpload.initInfo();
          _this.showTipPro = false;
        }
        _this.$forceUpdate();
      }
    },
    // 返回
    back:function (){
      this.$router.history.go(-1);
    },
    openIcPanel:function (e){
      $(e.target).parents('.ic-control').find('.other-ics').slideDown(300);
    },
    // 获取下拉框显示信息
    getSelectTxt: function (data, type){
      if(data){
        _this.viewBasicInfo[type] = data.label;
        if(type === 'cardNo'){
          _this.cardNoFlag = false;
          _this.isVirtualCard = false;
        }
      }
    },
    // 获取卡号列表
    getCardList: function () {
      _this.noCardFlag = false;
      let nextTime = _this.moment().valueOf();
      let interval = nextTime - _this.lastTime;
      _this.lastTime = nextTime;
      clearTimeout(_this.cardSearTimer);
      let tagIds = [];
      if (_this.cardTagIds && _this.cardTagIds.length > 0) {
        tagIds = _this.cardTagIds;
      } else if (_this.ApiService.userCardTags.Visitor.length > 0) {
        tagIds = _this.cardTagList.map(item => item.id);
      }
      _this.cardSearTimer = setTimeout(function () {
        let params = {
          enabledPaging: true,
          perPage: 10,
          page: _this.searchCard.page,
          tagIds: tagIds,
          statuses: [0],
          isAssigned: false,
          cardExtension: {
            "type": _this.ApiService.cardSettingInfo.mainType,
            "no": _this.searchCard.query
          }
        };
        /*时间间隔大于10时为输入搜索，小于10则为刷卡*/
        if (interval > 0 && interval < 10){
          params.cardExtension.type = null;
        }
        _this.shareApi.getCardList(params, true).done(result => {
          _this.searchCard.pageCount = result.pageCount;
          if(_this.curCardInfo.cardId){
            result.items.push(_this.curCardInfo);
          }
          matchCardNo(result.items);
          function matchCardNo(data){
            data.forEach(card =>{
              card.cardExtensions.forEach(item =>{
                if(item.type === _this.ApiService.cardSettingInfo.mainType){
                  _this.$set(card,'viewCardNo',_this.ApiService.cardSettingInfo.mainType + ' - ' + item.no);
                  _this.$set(card,'cardNo',item.no);
                }
              })
            })
            if(_this.searchCard.page > 1){
              _this.cardList = _this.cardList.concat(data);
            }else{
              _this.cardList = data;
            }
            _this.cardList =  _this.shareApi.dataDeduplication(_this.cardList,'cardId');
          }
          // 刷卡后存在，则默认为第一张卡
          if (interval > 0 && interval < 10 && _this.cardList.length > 0) {
            _this.userInfo.cardId = _this.cardList[0].cardId;
            _this.cardNoFlag = false;
            // 转换为主卡号显示
            _this.cardList[0].cardExtensions.forEach(item => {
              if (item.type === _this.ApiService.cardSettingInfo.mainType) {
                _this.$refs.QCardSelect.setQuery(item.no);
                _this.viewBasicInfo.cardNo = item.no;
              }
            })
          }
          else if (interval > 0 && interval < 10 && _this.cardList.length === 0) {
            _this.noCardFlag = true;
          }
        }).fail((error) => {
          _this.messageNotice('error', error);
        });
      }, 300);
    },
    changeQuery:function(value){
      this.searchCard.query = value;
      _this.searchCard.page = 1;
      _this.getCardList();
    },
    handScroll:function(){
      _this.getCardList();
    },
    // user卡号重置
    resetCardNo: function (flag) {
      if (flag) {
        _this.userInfo.cardId = null;
        _this.searchCard.page = 1;
        _this.searchCard.query = '';
        _this.cardList = [];
        _this.$refs.QCardSelect.setQuery('');
        _this.getCardList();
      }
    },
    sameIdSearch:function () {
      this.sameUserCount = 0
      this.$refs.userDetected.sameIdSearch();
    },
    getSameUserCount:function (num) {
      this.sameUserCount = num;
    },
    /*************用户AC************/
    // 新增AC
    addUserAC:function(){
      this.accessCodeName = '';
      this.searchHost = {page:1};
      this.acTagIds = [];
      this.searchAC = {};
      this.getACList();
      this.getHostList();
      this.editACFlag = false;
      this.userACInfo = {
        hostId:'',
        accessCodeIds:[],
        viewList:[],
        validityStartTime:_this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' ' + _this.ApiService.visitorACTime.split('-')[0],
        validityEndTime:_this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' ' + _this.ApiService.visitorACTime.split('-')[1],
      };
      this.acTagIds = [];
      this.acPage = 1;
      this.accessCodeFlag = false;
      this.acValidityFlag = false;
      this.hostFlag = false;
      this.accessCodeModal = true;
    },
    // 获取AC列表
    getACList:function(){
      clearTimeout(this.searchACTimer);
      let params = {
        accessCodeName:_this.accessCodeName,
        enabledPaging:false,
        sortType:0,
        sortName:'name',
        isTemp:false,
        userTypes:[1],
        departmentId:_this.searchAC.departmentId ? _this.searchAC.departmentId : null,
        tenantCompanyId:_this.searchAC.tenantCompanyId ? _this.searchAC.tenantCompanyId : null,
        tagIds:_this.acTagIds,
        types:[0],
        isFilterVac :true ,
        fileterByAccountRoleAc: true,
      };
      if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_AccessCode') === -1 ){
        return;
      }
      this.searchACTimer = setTimeout(function () {
        _this.shareApi.getACOptions(params).done(result =>{
          _this.accessCodeList = result;
          _this.judgeSelectAllAC();
        });
      },300);
    },
    // 选择AC
    checkAC: function (data) {
      let index = _this.userACInfo.viewList.findIndex(item => data.id === item.id);
      if (index > -1) {
        _this.userACInfo.viewList.splice(index, 1);
      } else {
        _this.userACInfo.viewList.push(data);
      }
      _this.accessCodeFlag = false;
      _this.judgeSelectAllAC();
    },
    cancelAC:function (data) {
      let index1 = _this.userACInfo.viewList.findIndex(item =>data.id === item.id);
      let index2 = _this.userACInfo.accessCodeIds.findIndex(id =>data.id === id);
      _this.userACInfo.viewList.splice(index1,1);
      _this.userACInfo.accessCodeIds.splice(index2,1);
      _this.judgeSelectAllAC();
    },
    // 修改AC信息
    modifyACInfo:function () {
      let flag = this.verifyAC();
      if(flag){
        let periodInfo = {
          validityStartTime: _this.userACInfo.validityStartTime ? _this.userACInfo.validityStartTime : null,
          validityEndTime:_this.userACInfo.validityEndTime ?  _this.userACInfo.validityEndTime : null
        }
        _this.userACData[_this.userACInfo.index].validityStartTime = periodInfo.validityStartTime;
        _this.userACData[_this.userACInfo.index].validityEndTime = periodInfo.validityEndTime;
        _this.userACData[_this.userACInfo.index].viewStatus = _this.shareApi.getUserACStatus(periodInfo, _this.userACData[_this.userACInfo.index].enableState,_this);
        _this.userACData[_this.userACInfo.index].lastUpdateTime = _this.moment().valueOf();
        _this.defaultSort();
        _this.userACInfo = {};
        _this.messageNotice('success');
        _this.accessCodeModal = false;
      }
    },
    // 验证AC
    verifyAC: function () {
      this.dateCompared(false,1,'userACInfo','validityStartTime','validityEndTime');
      if(!_this.editACFlag && _this.ApiService.visitorHostRequired && !_this.userACInfo.hostId)  {
        _this.hostFlag = true;
      }
      if(!_this.userACInfo.validityStartTime || !_this.userACInfo.validityEndTime)  {
        _this.acValidityFlag = true;
      }
      if (!_this.editACFlag && _this.userACInfo.accessCodeIds.length === 0){
        _this.accessCodeFlag = true;
      }
      return !(_this.acValidityFlag || _this.accessCodeFlag || _this.hostFlag);
    },
    // 编辑AC列表
    editAccessCode:function(data){
      this.editACFlag = true;
      this.userACInfo = {
        index:_this.findOptionIndex(data),
        validityStartTime:'',
        validityEndTime:'',
      };
      if(data.validityStartTime && data.validityEndTime){
        _this.userACInfo.validityStartTime = data.validityStartTime;
        _this.userACInfo.validityEndTime =data.validityEndTime;
      }
      this.accessCodeFlag = false;
      this.acValidityFlag = false;
      this.accessCodeModal = true;
    },
    // 删除AC
    deleteAC:function(data){
      _this.userACData.splice(_this.findOptionIndex(data),1);
    },
    // 状态改变
    changeACStatus:function(data){
      let index = _this.findOptionIndex(data);
      _this.userACData[index].enableState = (data.enableState === 0 ? 1 : 0);
      _this.userACData[index].viewStatus = _this.userACData[index].enableState;
      _this.userACData[index].lastUpdateTime = _this.moment().valueOf();
      _this.defaultSort();
    },
    // 保存AC
    saveACInfo:function () {
      let flag = this.verifyAC();
      if(flag){
        let periodInfo = {
          validityStartTime:_this.userACInfo.validityStartTime ? _this.userACInfo.validityStartTime : null,
          validityEndTime:_this.userACInfo.validityEndTime ?  _this.userACInfo.validityEndTime : null
        }
        _this.userACInfo.viewList.sort((a,b) =>{
          return b.name.localeCompare(a.name)
        });
          _this.userACInfo.viewList.forEach(item =>{
          _this.userACData.unshift({
            hostId:_this.userACInfo.hostId,
            hostName:_this.userACInfo.hostName,
            accessCodeName:item.name,
            accessCodeId:item.id,
            source:item.source,
            lastUpdateTime:_this.moment().valueOf(),
            validityStartTime:periodInfo.validityStartTime,
            validityEndTime:periodInfo.validityEndTime,
            enableState:0,
            operatorName:_this.$root.adminInfo.name,
            viewStatus: _this.shareApi.getUserACStatus(periodInfo, 0, _this),
            serialNumber:item.serialNumber
          });
        });
        _this.defaultSort();
        _this.userACInfo = {};
        _this.messageNotice('success',1);
        _this.accessCodeModal = false;
      }
    },
    //获取host相关信息
    getHostInfo:function (data) {
      _this.userACInfo.accessCodeIds = [];
      _this.userACInfo.viewList = [];
      _this.userACInfo.hostName = data.name;
      _this.searchAC.departmentId = data.departmentId ? data.departmentId : null;
      _this.searchAC.tenantCompanyId = data.tenantCompanyId ? data.tenantCompanyId : null;
      _this.getACList();
    },
    //获取host列表
    getHostList:function () {
      let params = {name:_this.searchHost.query || '',enabledPaging:true,perPage:10,page:_this.searchHost.page,userTypes:[0,3],sortType:0,sortName:'name'};
        _this.$ajax.post('User/Paging',params,{headers:{noLoading:true}}).then(function (res) {
          if(res.data.success){
            let array = res.data.data.items;
            _this.searchHost.pageCount = res.data.data.pageCount;
            if(_this.searchHost.page > 1){
              matchData(array);
            }else{
              _this.hostList = [{group:'Staff',items:[]},{group:'Tenant',items:[]}];
              matchData(array);
            }
            function matchData(data){
              data.forEach(user =>{
                if(user.userType === 0){
                  _this.hostList[0].items.push(user);
                }else{
                  _this.hostList[1].items.push(user);
                }
              });
            }
          }else{
            if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
          }
        })
    },
    hostHandScroll:function(){
      _this.getHostList();
    },
    hostQueryChange:function(name){
      _this.searchHost.query = name;
      clearTimeout(this.searchHost.timer);
      this.searchHost.timer = setTimeout(function () {
        _this.searchHost.page = 1;
        _this.getHostList();
      },1000);
    },
    hostSearchNow:function(){
      this.$refs.selectHost.visible = true;
      clearTimeout(this.searchHost.timer);
      _this.searchHost.page = 1;
      _this.getHostList();
    },
    // 获取所有选项(搜索词为空时不会触发remote-method，所以单独增加)
    getAllOptions:function (query) {
      if(!query){
        _this.getHostList();
      }
    },
    // 选择/取消所有AC
    checkAllACs:function () {
      let array1 = _this.accessCodeList.map(item => item.id);
      let set1 = new Set(array1);
      let set2 = new Set(_this.userACInfo.accessCodeIds);
      let set4 = new Set(_this.userACInfo.viewList);
      if(_this.userACInfo.checkAllAC){
        _this.userACInfo.accessCodeIds = Array.from(new Set([...set1,...set2]));
        _this.userACInfo.viewList = _this.shareApi.dataDeduplication(_this.accessCodeList.concat(_this.userACInfo.viewList));
      }else{
        _this.userACInfo.accessCodeIds = Array.from(new Set([...set2].filter(x => !set1.has(x))));
        _this.userACInfo.viewList = Array.from(new Set([...set4].filter(x => !set1.has(x.id))));
      }
      this.accessCodeFlag = false;
    },
    // 判断AC是否全选
    judgeSelectAllAC:function (){
      if(_this.userACInfo.accessCodeIds && _this.userACInfo.accessCodeIds.length > 0){
        _this.userACInfo.checkAllAC = _this.accessCodeList.every(item => _this.userACInfo.accessCodeIds.indexOf(item.id) > -1);
      }else{
        _this.userACInfo.checkAllAC = false;
      }
    },
    /*************用户AC************/

    getCheckedTags:function (data){
      this.viewBasicInfo.tagArray = data;
    },
    // 湖区卡类型tag
    getCardTags:function () {
      if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_TagManagement') === -1 ){
        return;
      }
      _this.shareApi.getTagOptions({enabledPaging:false,types:[4000]}).done(result =>{
        if(_this.ApiService.userCardTags.Visitor.length > 0){
          _this.cardTagList = result.filter(item =>{
            return _this.ApiService.userCardTags.Visitor.indexOf(item.name) > -1;
          });
        }else{
          _this.cardTagList = result;
        }
        if(_this.ApiService.cardSettingInfo.requiredUserTypes.indexOf(1) <= -1 && _this.ApiService.cardSettingInfo.isEnable){
          _this.getCardList();
        }
      })
    },
    
    applyInfo:function () {
      _this.$validator.validateAll('userInfo').then((result) => {
        if(_this.ApiService.cardSettingInfo.isEnable && _this.ApiService.cardSettingInfo.requiredUserTypes.indexOf(1) > -1 && !_this.userInfo.cardId){
          _this.cardNoFlag = true;
        }
        if (_this.ApiService.userFormField.Visitor['Face Photo'] && _this.ApiService.userFaceRequired.Visitor && !_this.userInfo.faceFileBase64) {
          _this.$set(_this.userInfo,"faceFlag",true);
        }
        if(_this.ApiService.visitorCompanySet.companies.length > 0 && _this.ApiService.visitorCompanySet.isRequired && !_this.userInfo.companyId) {
          _this.departmentFlag = true;
        }
        if( _this.ApiService.judgmentSwitch.Visitor && _this.ApiService.mustWrite.Visitor && !_this.userInfo.profilePhotoBase64){
        _this.showTipPro=true;
        return
        }
        if(result && !_this.cardNoFlag && !_this.userInfo.faceFlag && !_this.departmentFlag){
          _this.registerVisitor(false);
        }
      });
    },
    // 保存用户
    registerVisitor:function (isDirect) {
      let subData = JSON.parse(JSON.stringify(_this.userInfo));
      subData.addUserCustomizeManageDtos = this.customFields.map(item =>{
        return {id:item.id,content:item.content}
      });
      subData.enableState = (subData.enableState ? 0 : 1);
      subData.addIdentityCards = subData.addIdentityCards.filter(IC => (IC.no !== '' && IC.type !== ''));/*过滤空ID号码*/
      subData.userType = 1;
      subData.cardIds = subData.cardId ? [subData.cardId] : [];
      if(subData.companyId && subData.departmentType === 'Department'){
        subData.departmentId = subData.companyId;
      }
      if(subData.companyId && subData.departmentType === 'Tenant Company'){
        subData.tenantCompanyId = subData.companyId;
      }
      delete subData.companyId;
      delete subData.cardId;
      subData.addUserAccessCodeRelations = [];
      _this.userACData.forEach(item =>{
        subData.addUserAccessCodeRelations.push({
          "hostId":item.hostId ? item.hostId : null,
          "accessCodeId": item.accessCodeId,
          "startTime": _this.common.formatZoneDate(item.validityStartTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1),
          "endTime": _this.common.formatZoneDate(item.validityEndTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1),
          "enableState": item.enableState
        })
      });
      let list = [];
      subData.addUserDCSRelations.forEach((item)=>{
         list.push(item.value);
      });
      list.forEach(it=>{
        delete it.disNodeIds;
        delete it.allZoneList;
        delete it.zoneList;
        delete it.defaultZoneIds;
      });
      subData.addUserDCSRelations = list;
      subData.addUserDCSRelations.forEach((item)=>{
        if (item.isMandatory && (!item.endDCSAutoZoneId || !item.dcsAccessZoneIds.length )) {
          _this.dCSFlag = true;
        }
      });
      subData.addUserDCSRelations =  subData.addUserDCSRelations.filter(it=>{return it.targetNodeId !== null});
      if(_this.isUserTransform){
        subData.addUserDCSRelations.forEach((item)=>{
          if (item.isMandatory && !item.endDCSAutoZoneId || !item.dcsAccessZoneIds.length ) {
            _this.dCSFlag = true;
          }else {
            _this.dCSFlag = false;
          }
        });
      }
      if(_this.dCSFlag){
        _this.acTabIndex = 1 ;
      }else {
          this.$ajax.post('User/Create',subData).then(function (res) {
            if(res.data.success){
              _this.messageNotice('success',1);
              _this.closeModal();
            }else{
              _this.messageNotice('error',res.data.message);
            }
          })
       // }
      }
    },
    // 时间对比
    dateCompared:function (flag,type,objStr,startAttr,endAttr) {
      if (!flag) {
        let startData = _this.common.formatDate(_this[objStr][startAttr], _this.$root.Time[_this.$root.Time.type].typeDateHM, 2);
        let endData = _this.common.formatDate(_this[objStr][endAttr], _this.$root.Time[_this.$root.Time.type].typeDateHM,2);
        if (startData >= endData) {
          if (type === 0) { /*选开始时间*/
            _this[objStr][endAttr] = _this[objStr][startAttr].split(' ')[0] + ' 23:59';
          } else { /*选结束时间*/
            _this[objStr][startAttr] = '';
          }
        }
        if(startData < 0){
          _this[objStr][startAttr] = '';
        }
        if(endData < 0){
          _this[objStr][endAttr] = '';
        }
      }
    },
    /****************************附件上传******************************/
    handleUpload: function (file) {
      if(_this.userInfo.attachments.length>=3){
        _this.messageNotice('error', "Support 'eml','msg','png','gif','jpeg','txt','pdf','xlsx','xls','docx','doc' format. Maximum 3 attachments allowed and each one should not exceed 3MB");
        return false;
      }
      if (file.size < 1024 * 1024 * 3) {
        let formatStr = file.name.substr(file.name.lastIndexOf(".")).toLowerCase();
        if (['.eml', '.msg', '.png', '.gif', '.jpeg', '.jpg', '.txt', '.pdf', '.xlsx', '.xls', '.docx', '.doc'].indexOf(formatStr) > -1) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            let imgBase64 = this.result.substring(this.result.indexOf('base64,') + 7, this.result.length);
            _this.userInfo.attachments.push({'fileDataBase64': imgBase64, 'fileName': file.name,fileSize:file.size,url:this.result});
          };
        } else {
          _this.messageNotice('error', "Support 'eml','msg','png','gif','jpeg','txt','pdf','xlsx','xls','docx','doc' format. Maximum 3 attachments allowed and each one should not exceed 3MB");
        }
      } else {
        _this.messageNotice('error', "Support 'eml','msg','png','gif','jpeg','txt','pdf','xlsx','xls','docx','doc' format. Maximum 3 attachments allowed and each one should not exceed 3MB");
      }
      return false;
    },
    // 删除附件
    deleteAttachment: function (index) {
      _this.userInfo.attachments.splice(index, 1);
    },
    // 预览附件
    viewAttachment:function (file) {
      const a = document.createElement('a');
      a.download = file.fileName;
      a.href = file.url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    /****************************附件上传******************************/
    // 获取自定义字段
    setCustomFields:function(){
      _this.customFields = [];
      _this.ApiService.customsArray[1].forEach((value) => {
        let obj = value;
        _this.$set(obj, "content", "");
        _this.customFields.push(obj);
      });
    },
    getCardInfo:function (card) {
      _this.curCardInfo = card;
    },
    // 卡状态切换
    changCardStatus:function () {
      let params = {
        id:_this.curCardInfo.cardId,
        status:(_this.curCardInfo.status === 0 ? 1:0)
      };
      this.$ajax.post('Card/UpdateStatus',params).then(function (res) {
        if(res.data.success){
          _this.messageNotice('success');
          _this.curCardInfo.status = (_this.curCardInfo.status === 0 ? 1:0);
          _this.getCardList();
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    // 关闭弹框
    closeModal: function () {
      eventBus.$emit('closeRegistration');
    },
    // 获取刷卡信息
    initInfo:function () {
   
      _this.userInfo.addIdentityCards = _this.shareApi.getUserIDCount(1);
      if(!$.isEmptyObject(_this.$root.swipeCardInfo)){
        _this.userInfo.name = _this.$root.swipeCardInfo.name;
        setTimeout(()=>{
          _this.$set(_this.userInfo.addIdentityCards[0],'type',_this.$root.swipeCardInfo.idType);
          _this.$forceUpdate();
        },500)
        _this.userInfo.addIdentityCards[0].no = _this.$root.swipeCardInfo.idNumber;
      }

    },
    // 获取是否存在Single Entry配置
    hasSingleEntry: function () {
      this.$ajax.get('SignalEntryPolice/HasSignalEntryPolicy?officeId='+ this.userInfo.officeId).then(function (res) {
        if (res.data.success) {
          _this.exitSingleEntry = res.data.data;
        }
      });
    },
    // 配置Single Entry
    setSingleEntry: function () {
      if( _this.$root.adminInfo.permissionCodes.indexOf('M_SingleEntryPolicy') === -1){
        _this.messageNotice('error', "You don't have the permissions");
      }else{
        _this.$router.push({path: '/singleEntry'});
        _this.closeModal();
      }
    },
    // 查询AC tag
    getACTagList: function (name) {
      _this.shareApi.getTagOptions({enabledPaging: false,types:[2000],name:name},{headers:{noLoading:true}}).done(result => {
        _this.acTagList = result;
      })
    },
    // 获取自动分配卡
    getAutoAssignCard:function () {
      if(_this.ApiService.cardSettingInfo.isEnable && _this.ApiService.cardSettingInfo.requiredUserTypes.indexOf(1) > -1){
        //卡功能打开且卡号为必填才自动分配
        _this.shareApi.getDefaultCard(1,_this.userInfo.targetNodeId,_this).done(result =>{
        _this.userInfo.cardId = result.id;
        if(_this.userInfo.cardId){
          _this.isVirtualCard = true;
        }
        _this.viewBasicInfo.cardNo = result.cardText;
        _this.cardList = [{cardId:result.id,cardNo:result.cardText,viewCardNo:result.cardText}];
      })
      }
    },
    sortTable:function (data) {
      _this.shareApi.customSort(_this, data, _this.userACData);
    },
    // 默认按状态排序
    defaultSort:function () {
      _this.shareApi.customSort(_this, {column:{key:'viewStatus'},order:'desc'}, _this.userACData);
    },
    // 组织部门获取
    getDepartments:function () {
      let staffDep = (_this.ApiService.visitorCompanySet.companies.indexOf('0') > -1);
      let tenantDep = (_this.ApiService.visitorCompanySet.companies.indexOf('3') > -1);
      _this.isOrganizationCheck = (staffDep || tenantDep);
      _this.departmentArray = [{group:'Department',items:[]},{group:'Tenant Company',items:[]}];
      if(staffDep){
        getDepartment();
      }
      if(tenantDep){
        getTenantCompany();
      }

      // 获取部门
      function getDepartment() {
        _this.$ajax.post('Department/QueryComplanate', {enabledPaging: false,sortName:'name',sortType:0}).then(res => {
          if (res.data.success) {
            let array = res.data.data.items.filter(item => item.type === 0);
            _this.departmentArray[0].items = array;
          } else {
            if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
          }
        })
      }

      function getTenantCompany(){
        _this.$ajax.post('TenantCompany/QueryAccessCode',{enabledPaging:false,sourceType:1,sortName:'name'}).then(function (res) {
          if(res.data.success){
            let array = res.data.data;
            _this.departmentArray[1].items = array;
          }else{
            _this.messageNotice('error',res.data.message);
          }
        });
      }
    },
    getAutoAC:function (option,data) {
      _this.departmentFlag = false;
      _this.userInfo.company = data.name;
      _this.userInfo.departmentType = option.group;
    },
    changeACClass(type){
      this.shareApi.changeACClass(this,type);
    },
    findOptionIndex(data){
      let index = _this.userACData.findIndex(item => (item.accessCodeId === data.accessCodeId) && (item.lastUpdateTime === data.lastUpdateTime));
      return index;
    },
    // 获取默认的自动AC
    getDefaultAutoAC(){
      let params = {enabledPaging:false,sortType:0,sortName:'name',isAuto:true,userTypes:[1],types:[0]};
      let period = {
        validityStartTime : _this.moment().format(_this.$root.Time[_this.$root.Time.type].typeDateStr) + ' ' + _this.ApiService.visitorACTime.split('-')[0],
        validityEndTime: _this.moment().format(_this.$root.Time[_this.$root.Time.type].typeDateStr) + ' ' + _this.ApiService.visitorACTime.split('-')[1]
      };
      _this.shareApi.getACOptions(params).done(result =>{
        _this.userACData = JSON.parse(JSON.stringify(_this.userACData)).filter(item => item.conversionType || !item.userAccessCodeSource);
        let defaultAutoAC = result.map(item =>{
          return {
            accessCodeName: item.name,
            accessCodeId: item.id,
            source: item.source,
            validityStartTime: period.validityStartTime,
            validityEndTime: period.validityEndTime,
            enableState: 0,
            viewStatus:_this.shareApi.getUserACStatus(period, 0, _this),
            lastUpdateTime: _this.moment().valueOf(),
            userAccessCodeSource:1,/*0-手动添加 1-部门AC 2-Tenant部门AC*/
            operatorName:_this.$root.adminInfo.name,
            serialNumber:item.serialNumber
          }
        });
        _this.userACData = _this.userACData.concat(defaultAutoAC);
      });
    },

    //dcs相关修改
       //添加其他节点的DCS
       addNewDCSItem:function(){
        let disNodeIds = _this.userInfo.addUserDCSRelations.map(v => v.value.targetNodeId);
        _this.dcsArr = {
          value: {
            dcsAccessZoneIds: [],
            startDCSAutoZoneId: null,
            endDCSAutoZoneId: null,
            targetNodeId: null,
            disNodeIds: disNodeIds,
            allZoneList:[],
            zoneList:[],
          }
        };
        _this.dCSFlag = false;
        _this.editDcsFlag = false,
        _this.dcsModal = true;
      },
      //新增DCS
      saveDcsInfo(){
        let list = JSON.parse(JSON.stringify(_this.dcsArr.value));
        list.dcsAccessZoneIds = new Set(list.dcsAccessZoneIds);
        if(!list.targetNodeId){
          _this.dCSFlag = true;
          return
        }
        if (list.isMandatory && (!list.endDCSAutoZoneId || !list.dcsAccessZoneIds.size)) {
          _this.dCSFlag = true;
          return
        }
        _this.dCSFlag = false;
        if(_this.editDcsFlag){
          this.userInfo.addUserDCSRelations.splice(_this.editIndex,1,{value:list});
          this.diplayDCS.splice(_this.editIndex,1,_this.getDiplayDCS(list));
        }else{
          _this.userInfo.addUserDCSRelations.push({value:list});
          _this.diplayDCS.push(_this.getDiplayDCS(list));
        }
        console.log('_this.userInfo.addUserDCSRelations=',JSON.parse(JSON.stringify(_this.userInfo.addUserDCSRelations)));
        console.log('_this.diplayDCS=',JSON.parse(JSON.stringify(_this.diplayDCS)));
        _this.dcsModal = false;
        
      },
      getDiplayDCS(data){
        data = JSON.parse(JSON.stringify(data));
        this.$root.nodes.forEach(item => {
          if(item.id==data.targetNodeId){
            data.buildingId = item.id;
            data.buildingName = item.name;
          }
        })
        data.dcsAccessZones = [];
        data.allZoneList.forEach(item =>{
          data.dcsAccessZoneIds.forEach(item1 => {
            if(item.id == item1){
              data.dcsAccessZones.push({name:item.name})
            }
          })
          if(item.id == data.startDCSAutoZoneId){
            data.startDCSAutoZone = {name:item.name}
          }
          if(item.id == data.endDCSAutoZoneId){
            data.endDCSAutoZone = {name:item.name}
          }
        })
        if(data.dcsProfileId){
          let params =  {enabledPaging:false,sortName:"displayName",sortType:0};
          params.queryNodeId = data.targetNodeId;
          this.$ajax.post('DCSProfile/Paging',params).then(res=> {
            if(res.data.success){
              res.data.data.items.forEach(item => {
                if(item.id==data.dcsProfileId){
                  data.dcsProfile={displayName:item.displayName};
                  this.$forceUpdate();
                }
              })
            }
          });
        }
        return data;
      },
      //修改DCS
      modifyDcsInfo(index){
        let disNodeIds = _this.userInfo.addUserDCSRelations.map(v => v.value.targetNodeId);
        _this.dcsArr = JSON.parse(JSON.stringify(_this.userInfo.addUserDCSRelations[index]));
        disNodeIds = disNodeIds.filter(item=>{
          return item!=_this.dcsArr.value.targetNodeId;
        })
        _this.dcsArr.value.disNodeIds = disNodeIds;
        _this.dCSFlag = false;
        _this.editDcsFlag = true;
        _this.editIndex = index;
        _this.dcsModal = true;
      },
      // 删除DCS
      deleteDcs(index){
        _this.deleteType = 2;
        _this.deleteDCS = index;
        this.userInfo.addUserDCSRelations.splice(_this.deleteDCS,1);
        _this.diplayDCS.splice(_this.deleteDCS,1);
      },
      clearFileId(){
        _this.$set(_this.userInfo, 'profilePhotoFileId', null);
      },
      updatePalmPrintFeature(newPalmPrintFeature) {
        this.userInfo.palmPrintFeature = newPalmPrintFeature
      }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/visitorRegistration.js